module.exports = __webpack_public_path__ + "img/item-F.ffd55f9e.png";